const ARK_API_KEY ="d324963a-ba23-4945-a656-e7a1ae4eb6e5";
const url = 'https://ark.cn-beijing.volces.com/api/v3/chat/completions';
class OpenAiClient {
  async create(data: any) {
    try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${ARK_API_KEY}`
      },
      body: JSON.stringify({
        ...data,
        model: "doubao-1-5-pro-32k-250115",
      })
    });
    // 检查响应是否成功
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    // 解析响应数据
     return response.json();
  } catch (error) {
      throw new Error(`HTTP error!: ${error}`);
  }
  }
}
export const openai = () => {
  return new OpenAiClient();
};
